import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faGitlab } from "@fortawesome/free-brands-svg-icons";

export default class Projects extends Component {
  render() {
    return (
      <div>
        <div className="Projects">
          <p>
            Check out my GitHub or GitLab to see projects I've worked on or am
            currently working on! Thanks for stopping by! {">>"}
            <a
              href="https://github.com/rossfletcher19"
              target="_blank"
              rel="noopener noreferrer"
              className="iconLinks"
            >
              <FontAwesomeIcon icon={faGithub} />
            </a>
            <a
              href="https://gitlab.com/fletchlives"
              target="_blank"
              rel="noopener noreferrer"
              className="iconLinks"
            >
              <FontAwesomeIcon icon={faGitlab} />
            </a>
          </p>
        </div>
      </div>
    );
  }
}
